/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 */

export default [
  {
    id: 1,
    label: 'Email',
    field_name: 'email',
    source_field: 'email',
    customClass: 'email',
    showColumn: true,
    pinned: true,
  },
  {
    id: 2,
    label: 'First Name',
    field_name: 'first_name',
    source_field: 'first_name',
    showColumn: true,
    pinned: true,
  },
  {
    id: 3,
    label: 'Last Name',
    field_name: 'last_name',
    source_field: 'last_name',
    showColumn: true,
    pinned: true,
  },
  {
    id: 4,
    label: 'Group Name',
    field_name: 'group_name',
    source_field: 'group_name',
    showColumn: true,
  },
  {
    id: 5,
    label: 'External User Id',
    field_name: 'external_user_id',
    source_field: 'external_user_id',
    showColumn: true,
  },
  {
    id: 6,
    label: 'Course',
    field_name: 'course',
    source_field: 'course_name',
    showColumn: true,
  },
  {
    id: 7,
    label: 'Course Status',
    field_name: 'status',
    source_field: 'status',
    showColumn: true,
  },
  {
    id: 8,
    label: 'Unit Progress',
    field_name: 'unitProgress',
    source_field: 'completed_units_count',
    showColumn: true,
  },
  {
    id: 9,
    label: 'Date Started',
    field_name: 'date_started',
    source_field: 'date_started',
    showColumn: true,
  },
  {
    id: 10,
    label: 'Date Completed',
    field_name: 'date_completed',
    source_field: 'date_completed',
    showColumn: true,
  },
  {
    id: 11,
    label: 'Smart Course',
    field_name: 'smart',
    source_field: 'smart',
    showColumn: true,
  },
];
